import { isLocalhost } from "./isLocalhost";

/**
 * Get image src from setting value
 * @param settingValue - looks like this "i=1000000626&key=CE3EP8ITS2" or DEFAULT_XYZ
 */
export const getImageSrcFromSettingValue = (
  settingValue: string,
  idConcern: number
) => {
  if (settingValue === "DEFAULT_FAVICON") {
    return "/favicon.ico";
  }
  if (settingValue === "DEFAULT_LOGO") {
    return "/default-wt-logo.svg";
  }
  if (settingValue === "DEFAULT_WELCOME_PICTURE") {
    return "/undraw_generated/undraw_my-resume_etai.svg";
  }

  if (!settingValue) return null;

  const baseUrl = isLocalhost
    ? "https://secure.webtemp.no/cgi-win/test/jorgen/wtgetfile.exe"
    : "https://secure.webtemp.no/cgi-win/wtgetfile.exe";

  const url = new URL(baseUrl);

  const paramsFromSetting = new URLSearchParams(settingValue);

  url.searchParams.set("k", idConcern.toString());
  url.searchParams.set("allow-cache", "1");
  url.searchParams.set("a", "publicdoc");

  if (paramsFromSetting.has("key")) {
    url.searchParams.set("key", paramsFromSetting.get("key"));
  }

  if (paramsFromSetting.has("i")) {
    url.searchParams.set("i", paramsFromSetting.get("i"));
  }

  return url.toString();
};
